<input type="file" class="file-input"
       (change)="onFileSelected($event)" #fileUpload>

<div class="file-upload">
    <p>
        P.O. Number: {{itemInsert.trackingId}}
    </p>
    <p>
        Customer Id: {{itemInsert.custId}}
    </p>

    {{fileName || "No file uploaded yet."}}

    <button mat-mini-fab color="primary" class="upload-btn"
            (click)="fileUpload.click()">
        <mat-icon>attach_file</mat-icon>
    </button>


    <div>
        <h3>File Preview</h3>
        <pre> {{fileContent}} </pre>

        <h3 *ngIf=invalidArr> Invalid</h3>
        <pre> {{invalidArr}} </pre>
    </div>


</div>

